export default {
  install: (app) => {
    const logout = () => {

    };

    app.provide("logout", logout);
  },
};